import Indicator from '../Indicator';

/** Advance/Decline Indicator */
export default class AdvanceDeclineIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator Name
	 * @property {string} description - Indicator Description
	 * @property {object[]} inputs - The advancer and decliner inputs
	 */
	_getDefaultParams() {
		return {
			id: 'advancedecline',
			name: 'Advance/Decline Line',
			description:
				'The Advance/Decline Line is a breadth indicator based on Net Advances, which is the number of advancing stocks less the number of declining stocks. Net Advances is positive when advances exceed declines and negative when declines exceed advances.',
			inputs: [
				{ name: 'Advancers', value: 10025197 }, // hard-coded NYSE issues as defaults
				{ name: 'Decliners', value: 10025198 }
			]
		};
	}

	/** @param {object} data - Symbol data object */
	render(data, sessionType) {
		this.cumulativeAdjustment = this._getCumulativeAdjustment();
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
